import React from "react";
import { useTranslation } from "react-i18next";

const HoursHeader = () => {
  const { t } = useTranslation(); 

  return (
    <div className="w-100">
      <h3 className="txt-main m-0 fw-bold" style={{ fontSize: "24px" }}>
        {t('components.HoursHeader.title')} 
      </h3>
    </div>
  );
};

export default HoursHeader;